import { Button, Input, message, Modal } from "antd";
import { ReactNode, useState } from "react";
import { STATUS_REQUESTED } from "../../../constants/constants";
import CloseIcon from "../../../components/icons/CloseIcon";
import { sendSkipFeedback } from "../../../API/endpoints/Discovery";

interface Props {
    open: boolean;
    brandName: string;
    partnerName: string;
    onCancel: () => void;
    onSuccess: () => void;
}
const FeedbackModal = (props: Props) => {
    const { open, brandName, partnerName } = props;

    const [messageApi, conetxtHolder] = message.useMessage();

    const [text, setText] = useState("")
    const [submitLoading, setSubmitLoading] = useState(false);



    const onSubmit = () => {
        if (!text) {
            messageApi.warning("Please enter feedback text");
            return;
        }

        setSubmitLoading(true);
        const req = {
            partnerName: partnerName,
            brandName: brandName,
            text: text
        }
        sendSkipFeedback(req).then((res: any) => {
            props.onSuccess()
            setText("");
            messageApi.success("Feedback sent successfully.")
            setSubmitLoading(false);
        }).catch((err) => {
            console.error("err", err);
            messageApi.error("Failed to sen feedback. Please try again!")
            setSubmitLoading(false);
        })

    }

    const onClose = () => {
        props?.onCancel()
        setText("");
    }
    return (
        <Modal
            width={400}
            open={open}
            onCancel={() => onClose()}
            onOk={() => onSubmit()}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0",
                body: "!p-[20px]",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            title={(
                <div className="flex items-center justify-between">
                    <p className="m-0 font-[500] text-[13px]">
                        Help us improve - Why wasn't this a good fit?
                    </p>
                    <Button type="text" icon={<CloseIcon />} className="leading-[12px]" onClick={() => onClose()} />
                </div>

            )}
            okText="Submit Feedback"
            cancelText="Close"
            okButtonProps={{
                loading: submitLoading
            }}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            closeIcon={false}
        >
            {conetxtHolder}
            <Input.TextArea
                placeholder="Tell us why this partnership opportunity wasn't suitable for you.-"
                rows={4}
                value={text}
                onChange={(e) => setText(e.target.value)}
                className="!resize-none"
            />
        </Modal>
    )
}

export default FeedbackModal